var __rspack_ns_object = JSON.parse('{"Primary":"Primario","Recent":"Reciente","All":"Todos","Studies":"Estudios"}')